import ziState from './state_zi';
import luState from './state_lu';
const mainState = {
	/** App.vue 对应全局组件 **/
	/** 提示语 **/
	tooltip: false,
	tooltip_msg: '',
	/** 图标 **/
	tooltip_icon: '',
	tooltip_img: '',
	tooltip_className: '',
	tooltip_wrapclassName: '',

	/** 加载状态 **/
	loading: false,

	/** 请求状态 **/
	fetch_pending: false,

	/** vip开通成功后弹框 **/
	vip_success: false,
	vip_expiration_date: null,
	vip_success_desc: '',
	vip_success_close_callback: null,

	/** dialog **/
	dialog_alert: false,
	dialog_affirm: false,
	dialog_title: '',
	dialog_text: '',
	dialog_cancel_text: '取消',
	dialog_confirm_text: '确认',
	dialog_cancel_btn: new Function(),
	dialog_confirm_btn: new Function(),
	dialog_text_class: '',
	dialog_alert_data: [{ btn: '确定', callback: new Function() }],

	word_explain: false,
	word_explain_data: {},

	/** 招商合作的重要声明 **/
	zs_declaration: false,
	zs_declaration_data: null,
	zs_declaration_btn_callback: new Function(),

	/** app用户信息 **/
	appUserInfo: null,

	/** app相关 **/
	appClientInfo: null,

	/** 搜索关键词 **/
	searchKeyWord: '',

	/** 搜索页面返回标记 避免返回出发搜索 */
	isBackFirstSearch: false,

	/** 横向滑动菜单项对应对象 **/
	sliderItem: null,

	/** strophe 接收到的message **/
	stropheMsg: null,

	/** AgoraClient **/
	agoraClient: {},

	/** wx.config */
	wxConfigUrl: '',

	// 播放区域比例
	playerAreaRatio: '169',

	// 提取签字base64
	signBase64: '',

	// 搜索公司名称回显
	companyName: '',
	companyType: -1,

	// 判断是否网页版支付宝支付回来
	isALiPayCallBack: false,

	// 直播间在线计时器
	liveRoomOnlineTimer: null,

	/** auth-dialog **/
	auth_dialog: false,
	auth_dialog_type: 'phone',
	auth_dialog_require: false,
	auth_dialog_content: '',
	auth_dialog_close__btn: new Function(),
	auth_dialog_success__btn: new Function(),

	keepAlive: [],

	loginInfo: null,
	visaViewInfo: {},
	initialsAreaCode: ''
};

export default Object.assign(mainState, ziState, luState);
